import {Component, HostBinding, Input} from '@angular/core';
import { Config } from '../universal-config';

@Component({
  selector: 'nns-error',
  template: `
    <div class="nns-wrapper" flex layout="row" layout-align="center start">
      <div class="nns-error-page-content" flex="none" layout="column" layout-align="center center" *ngIf="currentOrganization !== undefined">
        <div class="nns-error-page-type"
             *ngIf="errorTemplate == '404'"
        >404</div>
        <div class="nns-error-page-title"
             *ngIf="errorTemplate == '404'"
        >The page you are looking for can’t be found</div>
        <div class="nns-error-page-promo"
             *ngIf="errorTemplate == '404' && isCnameDomain"
        >
          <div class="nns-error-page-promo-title">
            🔥 Huge! FuseBase AI Agents — your Dream Team of executive assistants that work 24/7 🔥
          </div>
          <style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; border-radius: 12px; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style><div class='embed-container'><iframe src='https://www.youtube.com/embed/Pm0FwTdwb74' frameborder='0' allowfullscreen></iframe></div>
          <div class="nns-error-page-promo-buttons">
            <a class="nns-error-page-promo-button" target="_blank" href="https://app.nimbusweb.me/auth/?f=register&amp;t=regfsour:screenshot-uninstall" rel="external noopener noreferrer">Try it free</a>
            <a class="nns-error-page-promo-button-store" target="_blank" href="https://chromewebstore.google.com/detail/fusebase-assistant-ai-cha/haafigbapbpbpnmgcknnmilaaaimggpk" rel="external noopener noreferrer">
							<img src="./dist/assets/chrome-web-store.png" alt="">
            </a>
          </div>
        </div>

        <div class="nns-error-page-title"
          *ngIf="errorTemplate == '403'"
        >You don't have permission to access this page</div>
        <div class="nns-error-page-img"
          *ngIf="errorTemplate == '403'"
        >
          <img src="./dist/assets/403.png">
        </div>
      </div>
    </div>
  `,
  styles: [`
    :host {
      position:relative;
      box-sizing:border-box;
      padding: 40px 0;
    }
    :host(.error-404) {
      padding: 0;
    }
    .nns-error-page-content {text-align:center;}
    nns-error-page .nns-wrapper {
      max-width:970px;
      min-width:320px;
      margin:0 auto;
      padding:0 10px;
    }
    .nns-error-page-type {
      font-weight:bold;
      font-size:235px;
      color:#EBEFF1;
      letter-spacing:-5.91px;
      line-height:1;
    }
    .nns-error-page-title {
      font-size:28px;
      color:#323348, 100%;
      padding:0 0 14px 0;
      line-height:1.3;
    }
    .nns-error-page-promo {
      margin-top: 32px;
      max-width: 752px;
      width: 100%;
      padding: 0 16px;
    }
    .nns-error-page-promo-title {
      font-size: 20px;
      margin-bottom: 27px;
      font-weight: 700;
    }
    .nns-error-page-promo-buttons{
     display: flex;
     align-items: center;
     gap: 18px;
     justify-content: center;
     margin-top: 20px;
    }
    .nns-error-page-promo-button{
      box-sizing: border-box;
      border-radius: 6px;
      background-color: #002730;
      color: #fff;
      font-family: "Inter", sans-serif;
      font-size: 16px;
      font-weight: 700;
      line-height: 140%;
      letter-spacing: -0.32px;
      padding: 13px 26px;
      outline: none;
      border: none;
      text-decoration: none;
      text-align: center;
      white-space: nowrap;
      position: relative;
      display: inline-block;
      transition: all .3s ease-in-out;
      z-index: 1;
      height: 48px;
      min-width: 194px;
      cursor: pointer;
    }
    .nns-error-page-promo-button-store{
      max-width: 206px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .nns-error-page-promo-button-store img{
      width: 100%;
      height: auto;
    }
    .nns-error-page-desc {
      font-size:18px;
      color:#2F3737;
    }
    .nns-error-page-img{
      max-width: 100%;
      margin-top: 80px;
    }
    .nns-error-page-img img{
      max-width: 100%;
    }
    @media only screen and (max-width: 768px) {

      .nns-error-page-type {
        font-size:150px;
        letter-spacing:-3.77px;
      }
      .nns-error-page-title {font-size:20px;}

    }
  `, `
    :host-context(.nns-theme-night) {
      background:#2f3737;
    }
    :host-context(.nns-theme-night) .nns-error-page-title {
      color:rgba(255,255,255, 0.6);
    }
    :host-context(.nns-theme-night) .nns-error-page-desc {
      color:#fff;
    }
  `]
})
export class ErrorComponent {
  @Input() errorCode;
  @Input() currentOrganization;

  errorTemplates = {
    "403": "403",
    default: "404"
  };
  errorTemplate;
  fileUrl;
  isCnameDomain: boolean;
  constructor(
    public _config: Config,
  ) {
    this.errorTemplate = this.errorTemplates.default;
    this.fileUrl = this._config.get('BOX_URL') + '/file/';
    this.isCnameDomain = ['nimbusweb.me', 'thefusebase.com', 'dev-thefusebase.com'].some(domain =>
      window.location.hostname.endsWith(domain)
    );
  }

  ngOnChanges(changes) {
    if (this.errorTemplates[this.errorCode]) {
      this.errorTemplate = this.errorTemplates[this.errorCode];
    }
  }
}
